var _style, _circle, _circle2, _path, _circle3, _path2, _circle4, _path3, _circle5, _path4, _circle6, _path5, _circle7, _path6, _circle8, _path7, _circle9, _path8, _circle0, _path9, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMulticlock3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:30.2177;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:10.0369;stroke-miterlimit:10;}\r\n\t.st2{stroke:#000000;stroke-width:7;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 512,
    cy: 512,
    r: 388.87
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 512.17,
    cy: 512,
    r: 73.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M512.17,560.09c-0.3-1.04-0.57-1.99-0.84-2.95c-3.81-13.32-7.61-26.64-11.43-39.96 c-0.91-3.17-0.84-6.28,0.57-9.28c1.97-4.2,5.29-6.73,9.88-7.44c6.47-1.01,12.75,3.27,14.3,9.65c0.52,2.13,0.55,4.26-0.04,6.38 c-1.03,3.72-2.1,7.43-3.16,11.14c-2.35,8.24-4.71,16.48-7.07,24.72C513.65,554.9,512.92,557.46,512.17,560.09z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 704.97,
    cy: 512,
    r: 73.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M704.97,560.09c-0.3-1.04-0.57-1.99-0.84-2.95c-3.81-13.32-7.61-26.64-11.43-39.96 c-0.91-3.17-0.84-6.28,0.57-9.28c1.97-4.2,5.29-6.73,9.88-7.44c6.47-1.01,12.75,3.27,14.3,9.65c0.52,2.13,0.55,4.26-0.04,6.38 c-1.03,3.72-2.1,7.43-3.16,11.14c-2.35,8.24-4.71,16.48-7.07,24.72C706.45,554.9,705.72,557.46,704.97,560.09z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 319.37,
    cy: 512,
    r: 73.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M319.37,560.09c-0.3-1.04-0.57-1.99-0.84-2.95c-3.81-13.32-7.61-26.64-11.43-39.96 c-0.91-3.17-0.84-6.28,0.57-9.28c1.97-4.2,5.29-6.73,9.88-7.44c6.47-1.01,12.75,3.27,14.3,9.65c0.52,2.13,0.55,4.26-0.04,6.38 c-1.03,3.72-2.1,7.43-3.16,11.14c-2.35,8.24-4.71,16.48-7.07,24.72C320.85,554.9,320.12,557.46,319.37,560.09z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 511.83,
    cy: 319.2,
    r: 73.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M511.83,367.29c-0.3-1.04-0.57-1.99-0.84-2.95c-3.81-13.32-7.61-26.64-11.43-39.96 c-0.91-3.17-0.84-6.28,0.57-9.28c1.97-4.2,5.29-6.73,9.88-7.44c6.47-1.01,12.75,3.27,14.3,9.65c0.52,2.13,0.55,4.26-0.04,6.38 c-1.03,3.72-2.1,7.43-3.16,11.14c-2.35,8.24-4.71,16.48-7.07,24.72C513.31,362.1,512.58,364.65,511.83,367.29z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 704.63,
    cy: 319.2,
    r: 73.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M704.63,367.29c-0.3-1.04-0.57-1.99-0.84-2.95c-3.81-13.32-7.61-26.64-11.43-39.96 c-0.91-3.17-0.83-6.28,0.57-9.28c1.97-4.2,5.29-6.73,9.88-7.44c6.47-1.01,12.75,3.27,14.3,9.65c0.52,2.13,0.55,4.26-0.04,6.38 c-1.03,3.72-2.1,7.43-3.16,11.14c-2.35,8.24-4.71,16.48-7.07,24.72C706.11,362.1,705.38,364.65,704.63,367.29z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 320.06,
    cy: 319.2,
    r: 73.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M320.06,367.29c-0.3-1.04-0.57-1.99-0.84-2.95c-3.81-13.32-7.61-26.64-11.43-39.96 c-0.91-3.17-0.84-6.28,0.57-9.28c1.97-4.2,5.29-6.73,9.88-7.44c6.47-1.01,12.75,3.27,14.3,9.65c0.52,2.13,0.55,4.26-0.04,6.38 c-1.03,3.72-2.1,7.43-3.16,11.14c-2.35,8.24-4.71,16.48-7.07,24.72C321.54,362.1,320.81,364.65,320.06,367.29z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 512.86,
    cy: 704.8,
    r: 73.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M512.86,752.89c-0.3-1.04-0.57-1.99-0.84-2.95c-3.81-13.32-7.61-26.64-11.43-39.96 c-0.91-3.17-0.84-6.28,0.57-9.28c1.97-4.2,5.29-6.73,9.88-7.44c6.47-1.01,12.75,3.27,14.3,9.65c0.52,2.13,0.55,4.26-0.04,6.38 c-1.03,3.72-2.1,7.43-3.16,11.14c-2.35,8.24-4.71,16.48-7.07,24.72C514.34,747.7,513.61,750.26,512.86,752.89z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 704.97,
    cy: 704.8,
    r: 73.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M704.97,752.89c-0.3-1.04-0.57-1.99-0.84-2.95c-3.81-13.32-7.61-26.64-11.43-39.96 c-0.91-3.17-0.84-6.28,0.57-9.28c1.97-4.2,5.29-6.73,9.88-7.44c6.47-1.01,12.75,3.27,14.3,9.65c0.52,2.13,0.55,4.26-0.04,6.38 c-1.03,3.72-2.1,7.43-3.16,11.14c-2.35,8.24-4.71,16.48-7.07,24.72C706.45,747.7,705.72,750.26,704.97,752.89z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 320.06,
    cy: 704.8,
    r: 73.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M320.06,752.89c-0.3-1.04-0.57-1.99-0.84-2.95c-3.81-13.32-7.61-26.64-11.43-39.96 c-0.91-3.17-0.84-6.28,0.57-9.28c1.97-4.2,5.29-6.73,9.88-7.44c6.47-1.01,12.75,3.27,14.3,9.65c0.52,2.13,0.55,4.26-0.04,6.38 c-1.03,3.72-2.1,7.43-3.16,11.14c-2.35,8.24-4.71,16.48-7.07,24.72C321.54,747.7,320.81,750.26,320.06,752.89z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulticlock3);
export default __webpack_public_path__ + "static/media/multiclock3.58df4a592dc1b445f6fbd0005bbc09e1.svg";
export { ForwardRef as ReactComponent };